<div class="dashboard">
  <div class="main-title dashboard-title"><span>Twój Pulpit</span></div>
  <div class="groupped">
    <div class="title">Moje aktualne karty</div>
    <div class="grid-wrapper small75">
      <div class="header">ICCID<br/>MSISDN</div>
      <div class="header">Plan taryfowy</div>
      <div class="header">Saldo<br/>[godz:min]</div>

      <ng-container *ngFor="let card of myCards">
        <div><a [routerLink]="['/card',card.iccid]">{{ card.iccid }}<br/>MSISDN: {{ card.msisdn }}</a></div>
        <div>{{ card.packagePlan }}</div>
        <div *ngIf="card.minutesLeft > 0">
          Pozostało czasu: {{ card.minutesLeft | formatMinutes }} [gg:mm]<br/>
          do: {{ card.expiryDate | date:'yyyy-MM-dd' }}
        </div>
        <div *ngIf="card.minutesLeft == 0  && card.expiryDate">
          Data ważności: {{ card.expiryDate | date:'yyyy-MM-dd' }}
        </div>
        <div *ngIf="card.minutesLeft == 0  && !card.expiryDate">
          &nbsp;
        </div>
      </ng-container>
    </div>
    <form>
      <div class="buttons" style="justify-content: space-between">
        <button>Potrzebuję nowej karty</button>
        <button>Odśwież salda</button>
      </div>
    </form>
  </div>
  <br/>
  <div class="groupped">
    <div class="title">Moje archiwalne karty</div>
    <div class="grid-wrapper small75">
      <div class="header">ICCID<br/>MSISDN</div>
      <div class="header">Plan taryfowy</div>
      <div class="header">Status</div>

      <ng-container *ngFor="let card of myArchivedCards">
        <div><a [routerLink]="['/card',card.iccid]">{{ card.iccid }}<br/>MSISDN: {{ card.msisdn }}</a></div>
        <div>{{ card.packagePlan }}</div>
        <div>{{ card.status }}</div>
      </ng-container>
    </div>
  </div>
  <br/>
  <div class="groupped"> <!-- sprawdz zdarzenia w card.component.html <- tam jest zrobiona tableka -->
    <div class="title">Ostatnie zdarzenia</div>
    <div class="event-wrapper small75">
      <div class="header">Data<br/>zdarzenia</div>
      <div class="header">ICCID<br/>MSISDN</div>
      <!--
            <div class="header">Plan taryfowy</div>
      -->
      <div class="header">Usługa</div>
      <div class="header">Dokąd (tel/sms)</div>
      <div class="header">Zużyto<br/>[godz:min]</div>

      <ng-container *ngFor="let event of myCardsEvents">
        <div>{{ event.eventDate | date:'yyyy-MM-dd HH:mm:ss' }}</div>
        <div>{{ event.iccid }}<br/>{{ event.msisdn }}</div>
        <!--
                <div>{{ event.packagePlan }}</div>
        -->
        <div>{{ event.serviceType | uppercase }}</div>
        <div>{{ event.destination }}</div>
        <div>{{ event.minutesUsed | formatMinutes }}</div>
      </ng-container>

    </div>
    <form>
      <div class="buttons" style="justify-content: end">
        <button onClick="orderBilling()">Zamawiam biling</button>
      </div>
    </form>
  </div>
  <footer class="content-footer">
    <img alt="logo" src="assets/parp-logo.jpg">
  </footer>
</div>
